import InputTextarea from './_input-textarea';

export default InputTextarea;
